import { widgetMessenger, dispatch, assemblePayload } from '@douban/rexxar-web';
import { rxrVersion } from '../../assets/js/version';
import { IS_TALION } from '../../assets/js/Globals';
var COMPATIBLE_NAME = rxrVersion.since('1.2') ? 'widget/' : '';
var COMPATIBLE_HOST = rxrVersion.since('1.2') ? 'rexxar-container' : 'rexxar.douban.com';
var Toast = /** @class */ (function () {
    /**
     * Show App Toast
     *
     * let toast = new Toast('error', '出错啦');
     * toast.work();
     *
     * @param {string} level ('info'|'error'|'fatal')
     * @param {string} message
     */
    function Toast(level, message) {
        this.toastInfo = {
            level: level,
            message: message,
        };
        this._messenger = widgetMessenger('douban', COMPATIBLE_HOST)("".concat(COMPATIBLE_NAME, "toast"));
    }
    Toast.prototype.work = function () {
        if (!IS_TALION) {
            dispatch(this._messenger(assemblePayload(this.toastInfo)));
        }
        else {
            var map = {
                info: 'success',
                error: 'warn',
                fatal: 'error',
            };
            if (window['dui'] && window['dui'].toast) {
                window['dui'].toast[map[this.toastInfo.level]](this.toastInfo.message);
            }
        }
    };
    return Toast;
}());
export default Toast;
//# sourceMappingURL=index.js.map